import { render, staticRenderFns } from "./save_cloud.vue?vue&type=template&id=05ec9335&scoped=true&"
import script from "./save_cloud.vue?vue&type=script&lang=js&"
export * from "./save_cloud.vue?vue&type=script&lang=js&"
import style0 from "./save_cloud.vue?vue&type=style&index=0&id=05ec9335&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec9335",
  null
  
)

export default component.exports